<button
  [cdkCopyToClipboard]="getLink()"
  (cdkCopyToClipboardCopied)="copiedLinkSuccess()"
  [matTooltip]="'Copier le lien'"
  mat-button
  type="button"
>
  <mat-icon>link</mat-icon>
</button>
